import { useState } from 'react';

function OrgResponsibilities({ items }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button className="project-button" onClick={() => setOpen(o => !o)}>
        Responsibilities
      </button>
      {open && (
        <ul className="responsibilities-list">
          {items.map((item, i) => <li key={i}>{item}</li>)}
        </ul>
      )}
    </>
  );
}

export default function OrganizationsOutput() {
  return (
    <div className="organizations-output">
      <h3>ClearCogs</h3>
      <p>ClearCogs builds tools that make complex data and workflows easier to understand and act on. They focus on clarity in dashboards, automation, and internal tooling so teams can move faster with less confusion.</p>
      <OrgResponsibilities items={[
        'Building and maintaining web applications and APIs',
        'Designing data models and integrations',
        'Writing tests and documentation',
        'Collaborating with product and design on new features and improvements',
      ]} />

      <h3>EdX Boot Camps</h3>
      <p>EdX Boot Camps deliver intensive, university-affiliated coding programs that prepare students for careers in software development through project-based learning. The curriculum emphasizes hands-on practice, real-world workflows, and the modern web stack, with cohorts moving quickly from fundamentals to full-stack application development.</p>
      <OrgResponsibilities items={[
        'Supporting instructors during live sessions on React app development',
        'Assisting a cohort of 15 students through their project work',
        'Answering technical questions in office hours and on Slack',
        'Demonstrating concepts like component architecture, state management, and hooks',
        'Debugging student code one-on-one',
        'Reviewing project submissions',
        'Reinforcing best practices around component reusability, props/state flow, and integrating APIs into React applications',
      ]} />
    </div>
  );
}
